import classNames from 'classnames';
import React from 'react';
import { useIntl } from 'react-intl';
import Button, { ButtonSize } from '../../../../../atoms/buttons/Button';
import css from './PurchaseBackToTop.module.scss';
import { buildSiteUrl } from 'src/utils/request-url';

interface ElementProps {}

type Props = ElementProps;

const PurchaseBackToTop: React.FC<Props> = () => {
  const intl = useIntl();
  const classes = classNames(css.PurchaseBackToTop);

  return (
    <div className={classes}>
      <Button
        isGhost={true}
        isFull={true}
        buttonSize={ButtonSize.Medium}
        href={buildSiteUrl()}
      >
        {intl.formatMessage({
          id: 'purchases.purchaseBackToTop.submitButton',
        })}
      </Button>
    </div>
  );
};

export default PurchaseBackToTop;
